import FormattedMessage from 'I18n/components/FormattedMessage';
import { useFetchHighlySensitivePropertyValue } from './useFetchHighlySensitivePropertyValue';
import styled from 'styled-components';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { useState } from 'react';
import { trackShowHighlySensitiveValueClick } from '../utils/usageTrackingUtils';
import { useProperty } from '../v2/hooks/useProperty';
import { useObjectTypeId } from '../v2/hooks/useObjectTypeId';
import { useFocused } from 'foundations-components/transitional/utils/useFocused';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingButtonWrapper = styled.span.withConfig({
  displayName: "ShowHighlySensitiveValueButton__LoadingButtonWrapper",
  componentId: "sc-2hrpsc-0"
})(["opacity:", ";transition:opacity 0.2s;"], ({
  $isVisible
}) => $isVisible ? 1 : 0);
export function ShowHighlySensitiveValueButton(props) {
  const {
    isVisible,
    className
  } = props;
  const {
    fetchHighlySensitivePropertyValue,
    highlySensitiveValueStatus
  } = useFetchHighlySensitivePropertyValue();
  const isLoading = highlySensitiveValueStatus === 'LOADING';
  const {
    onFocus,
    onBlur,
    focused
  } = useFocused({});
  const [showValueFailed, setShowValueFailed] = useState(false);
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized - Opacity and Transition are not tokenized via theme
    _jsx(LoadingButtonWrapper, {
      $isVisible: isVisible || isLoading || focused,
      children: /*#__PURE__*/_jsx(UILoadingButton, {
        className: className,
        size: "extra-small",
        use: "tertiary-light"
        // This prevents the success checkmark from showing when loading failed
        ,
        failed: showValueFailed,
        onClick: () => {
          trackShowHighlySensitiveValueClick({
            propertyName: property.name,
            objectTypeId
          });
          setShowValueFailed(false);
          fetchHighlySensitivePropertyValue().catch(() => {
            setShowValueFailed(true);
            FloatingAlertStore.addAlert({
              titleText: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "customerDataProperties.PropertyInputHighlySensitive.showValueErrorTitle"
              }),
              message: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "customerDataProperties.PropertyInputHighlySensitive.showValueErrorMessage"
              }),
              type: 'danger'
            });
          });
        },
        loading: isLoading,
        onFocus: onFocus,
        onBlur: onBlur,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.PropertyInputHighlySensitive.showValue"
        })
      })
    })
  );
}